import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import { Router } from "@angular/router";
import { Bot } from "../../../models/bot";
import { Event } from "../../../models/event";
import { EventType } from "../../../models/event-type";
import {Role} from "../../../models/role";
import { Store } from "../../../services/store.service";
import { RoleBotManageComponent } from "./components/manage/role-bot-manage.component";

@Component({
  selector: "app-new-bot",
  templateUrl: "./new-bot.component.html",
})
export class NewBotComponent implements OnInit {

  public role: Role;
  public serviceId: string;
  @Input() public bot: Bot = new Bot();
  @Input() public botName: string;
  @Input() public fromTab: boolean = false;
  @Input() public showBotAdd: boolean = false;
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public modalAddedEvent = new EventEmitter();
  @ViewChild(RoleBotManageComponent) public roleBotManageComponent: RoleBotManageComponent;

  constructor(private router: Router, private route: ActivatedRoute, public store: Store) {
  }

  public ngOnInit() {
    this.getParams();
    this.bot.name = this.botName;
    this.bot.shortName = this.botName ? this.botName.substring(0, 20) : "";
  }

  public getParams() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
  }

  public saveBot() {
    this.roleBotManageComponent.addNewBot();
  }

  public cancel() {
    this.modalClosedEvent.emit(new Event(null, EventType.Cancel));
  }

  public added() {
    this.modalAddedEvent.emit(new Event(null, EventType.Add));
  }

  public closeLayer() {
    this.router.navigate([`/services/${this.serviceId}/bots`]);
  }

}
